import { Controller } from "@hotwired/stimulus"
import { isHTMLInputElement } from "~/types/types.util"

// Connects to data-controller="exclusive-checkboxes"
// Makes the checkboxes inside the element mutually exclusive while still letting the checked one be unchecked.
export default class ExclusiveCheckboxesController extends Controller<HTMLElement> {
  static targets = ["checkbox"]

  declare readonly checkboxTargets: HTMLInputElement[]

  select({ target }: Event) {
    if (isHTMLInputElement(target) && target.checked) {
      this.checkboxTargets.forEach((checkbox) => {
        if (checkbox !== target) checkbox.checked = false
      })
    }
  }
}
